import { observable, action } from 'mobx';
import { WebGivingPage } from '../index';
import { FormField } from '../../components/form-field';
import { ValidationState, validateFields } from '../../validation/view-model-validator';
import { Country, ModelMetadata } from '../../webgiving-generated';
import { createRulesFromMetadata, combineValidators, RuleType, createValidatorFunc, fieldValidationSuccess, FieldValidationFailure } from '../../validation/validation-rules';
import { WebGivingPageViewModelBase } from '../page-view-model-base';
import { PhoneNumberUtils } from '../../utils/phone-number-utils';

export class PageEnterMobileNumberViewModel extends WebGivingPageViewModelBase {
	readonly type: WebGivingPage.EnterMobileNumber = WebGivingPage.EnterMobileNumber;

	@observable
	validationState?: ValidationState;

	mobileNumber: FormField<string>;
	mobileCountry: FormField<Country>;

	constructor(
		defaultMobileNumber: string = '',
		defaultCountry: Country,
	) {
		super();
		this.mobileNumber = new FormField<string>(PhoneNumberUtils.format(defaultMobileNumber, defaultCountry),
			combineValidators(createRulesFromMetadata(ModelMetadata.EnterMobileNumberRequest.MobileNumber), this.createMobilePhoneNumberValidator()));
		this.mobileNumber.updateSubject.register(this.synchronisePhoneCountryField);

		const country = PhoneNumberUtils.getRegionForNumber(defaultMobileNumber, defaultCountry);
		this.mobileCountry = FormField.Unvalidated(typeof country === 'number'? country : defaultCountry);
	}

	createMobilePhoneNumberValidator = () => createValidatorFunc((value: string) => {
		if (PhoneNumberUtils.isValidNumberForRegion(value, this.mobileCountry.value)) {
			return fieldValidationSuccess;
		}

		const errorMessage = ModelMetadata.EnterMobileNumberRequest.MobileNumber.validationRules
			? ModelMetadata.EnterMobileNumberRequest.MobileNumber.validationRules.length.errorMessage
			: 'That is not a recognised phone number';

		return new FieldValidationFailure(RuleType.Custom, errorMessage);
	}, RuleType.Custom)

	synchronisePhoneCountryField = (field: FormField<string>) => {
		const value = field.value;
		const newRegion = PhoneNumberUtils.getRegionForNumber(value, this.mobileCountry.value);

		if (typeof newRegion === 'number') {
			this.mobileCountry.updateValue(newRegion);
		}
	}

	@action
	validate(): ValidationState {
		return validateFields(this);
	}
}
